import * as React from "react"
import SvgText from "../../tools/SvgText";

function SchemaBraceletSiliconeClip12JeuneSVG(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={567.095}
            height={70.6}
            viewBox="0 0 567.095 70.6"

        >
            <g transform="translate(-.25 -19)">
                <path
                    d="M.5 19.3H510v34H.5z"
                    fill={props.braceletCouleur}
                    stroke="#000"
                    strokeWidth={0.5}
                />
                <path
                    d="M382.2 22.6V50H128.1V22.6h254.1m.5-.5H127.6v28.3h255.1z"
                    fill="#009fe3"
                />
                <text
                    transform="translate(195.862 84.362)"
                    fill="#b7b7b7"
                    fontSize={12}
                    fontFamily="Helvetica"
                >
                    <tspan x={0} y={0}>
                        {"Zone imprimable 90 x 10 mm"}
                    </tspan>
                </text>
                <path d="M164.2 72.1H181v17h-16.8z" fill="none" stroke="#009fe3" />
                <circle
                    cx={8.5}
                    cy={8.5}
                    r={8.5}
                    transform="translate(10 27.8)"
                    fill="#fff"
                    stroke="#000"
                    strokeMiterlimit={10}
                    strokeWidth={0.5}
                />
                <circle
                    cx={6.3}
                    cy={6.3}
                    r={6.3}
                    transform="translate(12.2 30)"
                    fill="none"
                    stroke="#000"
                    strokeMiterlimit={10}
                    strokeWidth={0.5}
                />
                <circle
                    cx={8.5}
                    cy={8.5}
                    r={8.5}
                    transform="translate(39.1 27.8)"
                    fill="#fff"
                    stroke="#000"
                    strokeMiterlimit={10}
                    strokeWidth={0.5}
                />
                <circle
                    cx={6.3}
                    cy={6.3}
                    r={6.3}
                    transform="translate(41.3 30)"
                    fill="none"
                    stroke="#000"
                    strokeMiterlimit={10}
                    strokeWidth={0.5}
                />
                <circle
                    cx={8.5}
                    cy={8.5}
                    r={8.5}
                    transform="translate(481 27.8)"
                    fill="#fff"
                    stroke="#000"
                    strokeMiterlimit={10}
                    strokeWidth={0.5}
                />
                <g data-name="Groupe 19">
                    <text
                        transform="translate(533.345 40.862)"
                        fill="#b7b7b7"
                        fontSize={12}
                        fontFamily="Helvetica"
                    >
                        <tspan x={0} y={0}>
                            {"12mm"}
                        </tspan>
                    </text>
                    <g data-name="Groupe 12" fill="none" stroke="#b7b7b7">
                        <path d="M523 53.3v-34" strokeMiterlimit={10} />
                        <path data-name="Ligne 6" d="M520 19.5h6" />
                        <path data-name="Ligne 7" d="M520 53.5h6" />
                    </g>
                </g>
                <g data-name="Groupe 28" fill="none" stroke="#b7b7b7">
                    <path d="M127.7 67.1h255" strokeMiterlimit={10} />
                    <path data-name="Ligne 10" d="M382.5 63.5v7" />
                    <path data-name="Ligne 11" d="M128 63.5v7" />
                </g>
            </g>
            <SvgText
                {...{
                    position: { x: 128, y: 2, width: 254.5, height: 28 },
                    lineStyle: { lineColor: "#000000", lineWidth: 0, lineType: "none" },
                    textStyle: props.apercuStyle,
                    motifs: props.motifs,
                    data: {
                        text: props.texteLigne1+((props.texteLigne2)?'\\n'+props.texteLigne2:''),
                        textVertical: false,
                        textAlignH: props.apercuStyle.textAlign,
                        textAlignV: "center"
                    }
                }}
            />
        </svg>

    )
}

export default SchemaBraceletSiliconeClip12JeuneSVG
